/* eslint-disable react/no-did-mount-set-state */
import axios from "axios";
import React, { PureComponent } from "react";
import QueryString from "query-string";
import Cookies from "js-cookie";

import { Redirect } from "../../../common/components";

/**
 * @typedef {Object} AuthState
 * @property {String} auth_destination - URL for session_token to be posted to
 * @property {String} destination - URL to redirect to
 */

/**
 * - Performs authorization request post to state.auth_destination with session_token in cookie
 * - Redirects to state.destination
 */
class RedirectSession extends PureComponent {
  static redirect(target) {
    return (<Redirect url={target} />);
  }

  constructor(props) {
    super(props);
    this.sessionToken = Cookies.get("session_token");
    this.state = {
      authCompleted: false, // Whether or not authorization request has been completed
    };
  }

  async componentDidMount() {
    if (!this.authState.auth_destination) return;

    try {
      await this.authorize();
    } catch (error) {
      // Silent error, component will redirect to state.destination regardless
    }

    this.setState({ authCompleted: true });
  }

  /**
   * Gets and decodes state from url parameters
   * @returns {AuthState}
   */
  get authState() {
    const { state } = QueryString.parse(this.props.location.search);
    return JSON.parse(atob(state));
  }

  async authorize() {
    const { auth_destination: authDestination } = this.authState;
    await axios.post(authDestination, {
      sessionToken: this.sessionToken,
    }, {
      withCredentials: true,
    });
  }

  render() {
    if (!this.state.authCompleted) {
      return null;
    }

    return this.constructor.redirect(this.authState.destination);
  }
}

export default RedirectSession;
